import { useContext, useState, useEffect, useMemo, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { AppContext } from '@utils/AppContext';
import { HOME_PAGE_TYPE, IMAGE_TYPE } from "@utils/CONST"
import eventBus from '@utils/eventBus'
import styles from './index.module.scss'
import PayModal from '@view/compoents/payModal/payModal'
import Iconfont from '@utils/Iconfont';
import { Popover } from 'antd';

import hp_cloth_normal from '@assets/images/home32x/hp_cloth_normal.svg';

import hp_model_normal from '@assets/images/home32x/hp_model_normal.svg';

import hp_shoes_normal from '@assets/images/home32x/hp_shoes_normal.svg';

import hp_video_normal from '@assets/images/home32x/hp_video_normal.svg';

import img2video_normal from '@assets/images/home32x/img2video_normal.svg';

import outfit_normal from '@assets/images/home32x/outfit_normal.svg';

import hp_goodsimage_normal from '@assets/images/home32x/hp_goodsimage_normal.svg';

import hp_goodscolorchange_normal from '@assets/images/home32x/hp_goodscolorchange_normal.svg';

import pose_image_normal from '@assets/images/home32x/pose_image_normal.svg';

import glass_image_normal from '@assets/images/home32x/glass_image_normal.svg';

import necklace_image_normal from '@assets/images/home32x/necklace_image_normal.svg';

import sim_image_normal from '@assets/images/home32x/sim_image_normal.svg';

import clothRecolor_normal from '@assets/images/home32x/clothRecolor_normal.svg';

import productShowcaseOutlined from '@assets/images/home32x/productShowcaseOutlined.svg';

import smartDetailPageOutlined from '@assets/images/home32x/smartDetailPageOutlined.svg';

import hp_bj_normal from '@assets/images/home32x/hp_bj_normal.svg';

import hp_watermark_normal from '@assets/images/home32x/hp_watermark_normal.svg';



const PREVIEW_BASE_URL = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/homepage_new/HomemainSidebar/'

const MENU_LIST = [
    {
        name: 'AI试衣',
        title: '保留版型生成试穿效果',
        key: IMAGE_TYPE.CLOTHES,
        icon: hp_cloth_normal,
        pathname: "/home/homemain/clothes"
    }, {
        name: '同版型试衣',
        title: '同版型服装一键替换，版型更精准',
        key: IMAGE_TYPE.SIM_TRYON,
        icon: sim_image_normal,
        pathname: "/home/homemain/simTryon"
    }, {
        name: '换模特',
        title: '一键切换不同模特',
        key: IMAGE_TYPE.MODEL,
        icon: hp_model_normal,
        pathname: "/home/homemain/model"
    }, {
        name: '鞋子上脚',
        title: '鞋款快速生成上脚效果',
        key: IMAGE_TYPE.SHOES,
        icon: hp_shoes_normal,
        pathname: "/home/homemain/shoesTryon"
    }, {
        name: '眼镜试戴',
        title: '眼镜快速生成试戴效果 ',
        key: IMAGE_TYPE.GLASSES_TRYON,
        icon: glass_image_normal,
        pathname: "/home/homemain/glassesTryon"
    },
    {
        name: '项链试戴',
        title: '项链快速生成上身效果 ',
        key: IMAGE_TYPE.NECKLACE_TRYON,
        icon: necklace_image_normal,
        pathname: "/home/homemain/necklaceTryon",
        newIcon: true
    },
    {
        name: '姿势裂变',
        title: '同一模特生成多种姿势',
        key: IMAGE_TYPE.POSE_TRYON,
        icon: pose_image_normal,
        pathname: "/home/homemain/poseTryon",
    }, {
        name: '商品换背',
        title: '商品图一键变换场景',
        key: IMAGE_TYPE.COMMODITY,
        icon: hp_goodsimage_normal,
        pathname: "/home/homemain/commodity"
    }, {
        name: '商品换色',
        title: '快速变换商品不同颜色',
        key: IMAGE_TYPE.COMMODITYRECOLOR,
        icon: hp_goodscolorchange_normal,
        pathname: "/home/homemain/commodityRecolor"
    }, {
        name: '动作模仿',
        title: '参考动作生成演绎视频',
        key: IMAGE_TYPE.MODEL_VIDEO,
        icon: hp_video_normal,
        pathname: "/home/homemain/model_video",
        teamIcon: true
    }, {
        name: '服饰换色',
        title: '快速切换服饰不同颜色',
        key: IMAGE_TYPE.CLOTH_RECOLOR,
        icon: clothRecolor_normal,
        pathname: "/home/homemain/clothRecolor",
    }, {
        name: '图生视频',
        title: '静态图片生成动态视频',
        key: IMAGE_TYPE.IMAGE_TO_VIDEO,
        icon: img2video_normal,
        pathname: "/home/homemain/model_video_img",
        teamIcon: true
    }, {
        name: '搭配上身',
        title: '多件服饰生成搭配效果',
        key: IMAGE_TYPE.FUSION_WEAR,
        icon: outfit_normal,
        pathname: "/home/homemain/fusionWear"
    }, {
        name: '种草图',
        title: '快速生成营销种草图片',
        key: IMAGE_TYPE.GRASS_PLANT,
        icon: productShowcaseOutlined,
        pathname: "/home/homemain/grassPlant",
        // newIcon: true
    }, 
    // {
    //     name: '服装详情页',
    //     title: '一键生成电商详情页长图',
    //     key: IMAGE_TYPE.SMART_DETAILA_PAGE,
    //     icon: smartDetailPageOutlined,
    //     pathname: "/home/homemain/smartDetailPage",
    //     newIcon: true
    // }, 
    {
        name: '服饰上身',
        key: '服饰上身',
        groupTitle: true,
        itemHeight: 20,
        itemMarginTop: 16
    }, {
        name: '组图生成',
        key: '组图生成',
        groupTitle: true,
        itemHeight: 20,
        itemMarginTop: 16
    }, {
        name: '电商内容生成',
        key: '电商内容生成',
        groupTitle: true,
        itemHeight: 20,
        itemMarginTop: 16
    }, {
        name: '换背景',
        title: '模特图一键变换场景',
        key: IMAGE_TYPE.BACKGROUND,
        icon: hp_bj_normal,
        pathname: "/home/homemain/background"
    }, {
        name: '商品美化',
        key: '商品美化',
        groupTitle: true,
        itemHeight: 20,
        itemMarginTop: 16
    }, {
        name: '去水印',
        title: '一键去除水印和文字',
        key: IMAGE_TYPE.WATERMARK_REMOVE,
        icon: hp_watermark_normal,
        pathname: "/home/homemain/watermarkRemove",
        // newIcon: true
    }, {
        name: 'AI视频',
        key: 'AI视频',
        groupTitle: true,
        itemHeight: 20,
        itemMarginTop: 16
    },
]

const MENU_MAP = MENU_LIST.reduce((acc, item) => {
    acc[item.key] = item
    return acc
}, {})

const Sidebar = () => {
    const navigate = useNavigate();
    const { globalHomePageType } = useContext(AppContext);
    const location = useLocation()

    // 侧边栏列表
    const menuList = useMemo(() => {
        if (globalHomePageType == HOME_PAGE_TYPE.CLOTHING) {
            return [
                MENU_MAP['服饰上身'],
                MENU_MAP[IMAGE_TYPE.CLOTHES],
                MENU_MAP[IMAGE_TYPE.SIM_TRYON],
                MENU_MAP[IMAGE_TYPE.SHOES],
                MENU_MAP[IMAGE_TYPE.GLASSES_TRYON],
                MENU_MAP[IMAGE_TYPE.NECKLACE_TRYON],
                MENU_MAP[IMAGE_TYPE.FUSION_WEAR],
                MENU_MAP['组图生成'],
                MENU_MAP[IMAGE_TYPE.MODEL],
                MENU_MAP[IMAGE_TYPE.BACKGROUND],
                MENU_MAP[IMAGE_TYPE.POSE_TRYON],
                MENU_MAP[IMAGE_TYPE.CLOTH_RECOLOR],
                MENU_MAP['电商内容生成'],
                MENU_MAP[IMAGE_TYPE.GRASS_PLANT],
                // MENU_MAP[IMAGE_TYPE.SMART_DETAILA_PAGE],
                MENU_MAP['商品美化'],
                MENU_MAP[IMAGE_TYPE.COMMODITY],
                MENU_MAP[IMAGE_TYPE.COMMODITYRECOLOR],
                MENU_MAP[IMAGE_TYPE.WATERMARK_REMOVE],
            ]
        } else if (globalHomePageType == HOME_PAGE_TYPE.MODEL_VIDEO) {
            return [
                MENU_MAP['AI视频'],
                MENU_MAP[IMAGE_TYPE.MODEL_VIDEO],
                MENU_MAP[IMAGE_TYPE.IMAGE_TO_VIDEO],
            ]
        } else return []
    }, [globalHomePageType])

    const handleSpanClick = (menu) => {
        navigate(menu.pathname)
    }

    const renderPopoverContent = (menu) => {
        const pathLastWord = menu?.pathname?.split('/').filter(Boolean).pop()
        if (!pathLastWord) return null
        const previewName = pathLastWord

        const isVideo = previewName === 'model_video_img' || previewName === 'model_video'

        return (
            <div className={styles.MenuPreviewCard}>
                <div className={styles.MenuPreviewTitle}>{menu.title}</div>
                {isVideo ? (
                    <video
                        className={styles.MenuPreviewVideo}
                        src={`${PREVIEW_BASE_URL}${previewName}.mp4`}
                        autoPlay
                        loop
                        muted
                        playsInline
                    />
                ) : (
                    <img className={styles.MenuPreviewImage} src={`${PREVIEW_BASE_URL}${previewName}.png`} alt={menu.name} />
                )}
            </div>
        )
    }

    return (
        <div className={styles.Sidebar}>
            <div className={styles.Sidebar_top}>
                {
                    menuList.map(menu => {
                        const isActive = location.pathname == menu.pathname
                        return (
                            <div
                                key={menu.key}
                                className={styles.Sidebar_item}
                                style={
                                    menu.itemHeight || menu.itemMarginTop
                                        ? {
                                            ...(menu.itemHeight ? { height: `${menu.itemHeight}px` } : {}),
                                            ...(menu.itemMarginTop ? { marginTop: `${menu.itemMarginTop}px` } : {})
                                        }
                                        : undefined
                                }
                                onClick={() => handleSpanClick(menu)}
                            >
                                {
                                    menu.groupTitle ? <div className={styles.Sidebar_item_title}>{menu.name}</div> :
                                        <Popover placement="right" content={renderPopoverContent(menu)}>
                                            <div className={`${styles.Sidebar_item_content} ${isActive ? styles.Sidebar_item_content_active : ''}`}>
                                                <img
                                                    className={styles.sidebar_icon}
                                                    src={menu.icon}
                                                    style={{
                                                        filter: isActive
                                                            ? 'invert(30%) sepia(100%) saturate(3700%) hue-rotate(205deg) brightness(101%) contrast(101%)'
                                                            : 'brightness(0) saturate(100%) invert(40%) sepia(10%) saturate(731%) hue-rotate(175deg) brightness(90%) contrast(90%)'
                                                    }}
                                                    alt=""
                                                />
                                                <p>{menu.name}</p>
                                                {menu.teamIcon && <span className={styles.teamIcon}></span>}
                                                {menu.newIcon && <span className={styles.newIcon}></span>}
                                            </div>
                                        </Popover>
                                }
                            </div>
                        )
                    })
                }
            </div>
            <div className={styles.Sidebar_bottom}>
                <div className={styles.RechargeTrigger} onClick={() => eventBus.emit('recharge')}>
                    <Iconfont type='icon-arcbeanrecharge' className={styles.Icon} />
                    <span>虹豆充值</span>
                </div>
                <div className={styles.ComplianceCopy}>
                    <span>结果由AI生成</span>
                    <span>持续调优中，请谨慎甄别</span>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
